import { invoice } from '@tma.js/sdk';
import { subscriptionApi } from '../api/subscriptionApi';

/**
 * Create a Stars checkout invoice and open it in Telegram.
 * @returns invoice status: 'paid' | 'cancelled' | 'failed' | 'pending'
 */
export async function openStarsCheckout(planCode: string): Promise<string> {
  const response = await subscriptionApi.createCheckout({
    planCode,
    successUrl: `${window.location.origin}/subscription?success=true`,
    cancelUrl: `${window.location.origin}/subscription?cancelled=true`,
  });

  const status = await invoice.openUrl(response.checkoutUrl);
  return status;
}
